<template>
	<div class="content-scroll">
		<div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
				<el-tab-pane label="跟踪记录" name="first"></el-tab-pane>
			</el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus" title="新增">新增</el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="company">
                    <el-input clearable v-model="filters.company" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item label="跟踪日期">
                    <el-date-picker size="small" v-model="timeRange" @change="getTimeRange($event,'trackTimeStart','trackTimeEnd')" type="daterange" value-format="yyyy-MM-dd" :picker-options="recentOptions" range-separator="-" start-placeholder="申请开始日期" end-placeholder="申请结束日期" align="right"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="warning" @click="handleExport()">导出</el-button>
                </el-form-item>
                <el-form-item>
                    <el-upload
                        ref='import'
                        :action="root + uploadUrl"
                        :show-file-list="false"
                        :on-success="importSuccess"
                        :before-upload="beforeImportFile"
                        :on-error="handleError"
                        :headers="{'username': username }">
                        <el-button size="small" type="warning">跟踪记录导入</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <!--列表-->
            <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
                <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="contact" label="联系人"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="company" label="公司"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="content" label="跟踪内容"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="trackTime" label="跟踪时间" align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)" icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)" icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"  :page-size="filters.pageSize" layout="total, prev, pager, next" :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '记录编辑':'记录新增'" :visible.sync="aVisible" width="50%" :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="120px" ref="formFileds" size="small">
                    <el-form-item label="跟踪客户：" prop="customerId" class="w450">
                        <el-button size="small" :type="formData.customerId ? '' : 'primary'" @click="cVisible = true">{{ formData.customerId ? '已选择Id(' + formData.customerId + ')' : '选择客户'}}</el-button>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="company" class="w350">
                        <el-input clearable v-model="formData.company"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contact" class="w350">
                        <el-input clearable v-model="formData.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="国家" prop="country" class="w350">
                        <el-input clearable v-model="formData.country"></el-input>
                    </el-form-item>
                    <el-form-item label="跟踪内容" prop="content" class="w350">
                        <el-input clearable type="textarea" :rows="2" v-model="formData.content"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary" @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)" :loading="bLoading">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <el-dialog :visible.sync="cVisible" width="1300px" :modal-append-to-body="true" :close-on-click-modal="false" top="5%">
                <div class="solt-header">
                    <h2>客户选择</h2>
                </div>
                <customer-list v-if="cVisible" @material="setMaterial"></customer-list>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomerList from '@/components/CustomerList.vue'
export default {
    components:{
        CustomerList,
    },
    data() {
        return {
            pageUrl:'/customer/track/record/list/page',
            updateUrl:'/customer/track/record/saveOrUpdate',
            addUrl:'/customer/track/record/saveOrUpdate',
            deleteUrl:'/customer/track/record/remove',
            exportUrl:'/customer/track/record/export',
            importUrl:'/customer/track/record/import',

            filters:{
                pageSize: 10,
                pageIndex: 1,
                customerId: null,
                company:'',
                country:'',
                trackTimeEnd:'',
                trackTimeStart:'',
            },
            
            formData:{
                customerId:'',
                company:'',
                contact:'',
                country:'',
                content:'',
                id:'',
            },
            formRules: {
                customerId: [
                    { required: true, message: '请选择跟踪客户', trigger: 'blur' } 
                ],
                company: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' } 
                ],
            },
        }
    },
    computed:{
        ...mapGetters(['username'])
    },
    methods: {
        setMaterial(row){
            this.cVisible = false;
            this.formData.customerId = row.id;
            row.id = this.formData.id;
            this.mergeObject(this.formData, row)
        },
    },
    mounted(){
        this.filters.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
        this.formData.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null

        this.formData.company = this.$route.query.company
        this.formData.contact = this.$route.query.contact
        this.formData.country = this.$route.query.country

        this.getPage()
    }
}
</script>